import { BaseContainerModel } from "../../base-container.model";
import { alg_bot_cf_element_hdr_RowClass } from "../../../dbschema";

export class BotCfElementHdrContainerModel extends BaseContainerModel{
  alg_bot_cf_element_hdr: alg_bot_cf_element_hdr_RowClass = new alg_bot_cf_element_hdr_RowClass();
}
